import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { removeFromStore } from '../../utils/fn';
import Product from './Product';
import constants from '../../utils/constants.json';
import { setFavorites } from '../../store/favorites';
import icons from '../../utils/icons.json';

function Favorites() {
	const dispatch = useDispatch();
	useDocumentTitle('Favorite Items');

	const favorites = useSelector(state => state.favorites.data);

	useEffect(() => { 
		window.scroll({ top: 0, behavior: 'smooth' });
	}, []);

	function clearFavorites() {
		removeFromStore(constants.FAVORITES);
		dispatch(setFavorites([])); 
	}

	return (
		<div className='main-body'>
			<div className='sections' style={{ paddingBottom: '50px' }}>
				<section className='title'>
					<h3>Favorite Items</h3>
					{favorites.length > 0 && <button onClick={clearFavorites} className='link-btn' type='button' dangerouslySetInnerHTML={{ __html: 'Clear All' + icons.trash }} />}
				</section>
				{favorites.length === 0 && <p style={{ padding: '10px 10px 300px' }}>You currently don't have any favorites items.</p>}
				<div className='products-view'>
					{favorites.map((product, index) => (
						<Product data={product} key={product.item_code} />
					))}
				</div>
			</div>
		</div>
	);
}

export default React.memo(Favorites);
